module.exports = __webpack_public_path__ + "img/added-service-unit-03.34f8ac6d.png";